import { trimLeft } from 'lodash';

function validateGrade (data, errors) {
  const { grade } = data;

  if (!grade) {
    errors.grade = 'Required';
  } else if (grade.length > 80) {
    errors.grade = 'Please use a shorter name';
  }
}

function validateDivisionName (data, errors) {
  const { divisionName } = data;

  if (!divisionName) {
    errors.divisionName = 'Required';
  } else if (divisionName.length > 80) {
    errors.divisionName = 'Please use a shorter name';
  }
}

function validateNumberOfStudents (data, errors) {
  const { numberOfStudents } = data;

  if (parseInt(numberOfStudents, 10) > 0) {
    return;
  }
  if (parseInt(numberOfStudents, 10) > Number.MAX_SAFE_INTEGER) {
    errors.numberOfStudents = 'Too high';
    return;
  }
  errors.numberOfStudents = 'Must be more than zero';
}

function validateProgram (data, errors) {
  const { program} = data;

  if (program) {
    return;
  }
  errors.program = 'Required';
}

function validateLanguage (data, errors) {
  const { language } = data;

  if (language) {
    return;
  }
  errors.language = 'Required';
}

export function validateClass (data) {
  const errors = {};

  validateProgram(data, errors);
  validateLanguage(data, errors);
  validateGrade(data, errors);
  validateDivisionName(data, errors);
  validateNumberOfStudents(data, errors);

  return errors;
}

export const normalizeClass = {
  grade: value => value && trimLeft(value),
  divisionName: value => value && trimLeft(value)
};



// WEBPACK FOOTER //
// ./src/views/dashboard/validateClass.js